// Translation: Russian > Time
const time = Object.freeze({
	day_one: '',
	day_other: '',
	dayInShort: '',
	dayWithType_one: '',
	dayWithType_other: '',
	frequencyItems: {
		once: '',
		perUse: ''
	},
	hour_one: '',
	hour_other: '',
	hourInShort: '',
	hourWithType_one: '',
	hourWithType_other: '',
	minute_one: '',
	minute_other: '',
	minuteInShort: '',
	minuteWithType_one: '',
	minuteWithType_other: '',
	month_one: '',
	month_other: '',
	monthInShort: '',
	monthWithType_one: '',
	monthWithType_other: '',
	rangeItems: {
		last24Hours: '',
		last30Days: '',
		last7Days: '',
		thisMonth: '',
		thisWeek: '',
		thisYear: '',
		today: ''
	},
	second_one: '',
	second_other: '',
	secondInShort: '',
	secondWithType_one: '',
	secondWithType_other: ''
})

// Export
export default time
